import React from 'react';
import * as styles from './index.module.less';
import CommonBlok from '@/components/common-blok';
import { H2 } from '@/components';
import UsingBtn from '@/components/using-btn';
import RatioMedia from '@/components/ratio-media';

const CtaBtn = ({ className = '' }) => {
  return <UsingBtn type="gradual" label="営業担当に相談" link="/enterprise" btnWrapperClass={className} />;
};

export const AI_NOTE_ID = 'ai-note';

const AINote = () => {
  return (
    <CommonBlok isNewLayout paddingBottom="0" id={AI_NOTE_ID}>
      <div className={styles.wrapper}>
        <div className={styles.inner}>
          <div className={styles.new_tag}>New</div>
          <div className={styles.content_wrapper}>
            <H2 className={styles.content_title} isWordKeepAll>
              内容
              <wbr />の<wbr />
              振り返り、
              <br /> 議事録作成
              <wbr />も<wbr />
              時短
            </H2>
            <div className={styles.content_desc}>
              <ul>
                <li>
                  <p>
                    文字起こし
                    <wbr />の<wbr />
                    編集
                    <wbr />
                    だけ
                    <wbr />で<wbr />
                    なく、
                    <wbr />
                    生成された
                    <wbr />
                    要約
                    <wbr />を<wbr />
                    手動
                    <wbr />で<wbr />
                    編集
                    <wbr />
                    できます。
                    <wbr />
                    クリック
                    <wbr />
                    して
                    <wbr />
                    いつでも
                    <wbr />元<wbr />の<wbr />
                    音声データ
                    <wbr />を<wbr />
                    かんたんに
                    <wbr />
                    確認
                    <wbr />
                    できます。
                    <wbr />
                    工数
                    <wbr />の<wbr />
                    負担
                    <wbr />を<wbr />
                    劇的に
                    <wbr />
                    削減する
                    <wbr />と<wbr />
                    同時に、
                    <wbr />
                    議事録
                    <wbr />と<wbr />
                    音声
                    <wbr />で<wbr />
                    情報共有
                    <wbr />を<wbr />
                    効率化。
                  </p>
                </li>
                <li>
                  <p>
                    エンタープライズプラン
                    <wbr />の<wbr />
                    場合
                    <wbr />
                    は、
                    <wbr />
                    テンプレート
                    <wbr />は<wbr />
                    カスタマイズ可能
                    <wbr />
                    です。
                    <wbr />
                    役職者会議、
                    <wbr />
                    協議会、
                    <wbr />
                    報告会、
                    <wbr />
                    営業会議
                    <wbr />
                    など、
                    <wbr />
                    様々な会議
                    <wbr />に<wbr />
                    利用可能し、
                    <wbr />
                    異なる
                    <wbr />
                    部署
                    <wbr />や<wbr />
                    全社に
                    <wbr />
                    導入する
                    <wbr />
                    こと
                    <wbr />が<wbr />
                    便利。
                  </p>
                </li>
              </ul>
            </div>
            <CtaBtn className={styles.content_btn} />
          </div>
          <div className={styles.cover_wrapper}>
            <RatioMedia
              media={{
                type: 'image',
                src: 'https://www.notta.ai/pictures/AI-Summary-v2.png',
                alt: 'Notta AI要約機能',
                objectFit: 'cover',
              }}
              isLazyLoad
              ratio={3 / 4}
            />
            <CtaBtn className={styles.bottom_cta_btn} />
          </div>
        </div>
      </div>
    </CommonBlok>
  );
};
export default AINote;
